import React from 'react';

const AboutUs: React.FC = () => {
  return (
    <section id="about" className="py-20">
      <div className="container mx-auto px-6">
        {/* Spans the content column like every other section on the page. */}
        <div className="text-center">
          <h2 className="text-3xl font-bold mb-4 text-gray-800">Our Story</h2>

          <p className="mb-8 text-gray-700 story-paragraph">
            Mischief didn't have an easy start. Like a lot of pit bulls, she was the kind of dog
            people wrote off — misjudged, overlooked, the first to be given up on. Then she got adopted.
          </p>

          <p className="mb-8 text-gray-700 story-paragraph">
            She turned out to be everything a dog is supposed to be. She didn't care about anyone's
            title or bad day — she just loved her people, completely.
          </p>

          <p className="mb-8 text-gray-700 story-paragraph">
            That love made the rest impossible to ignore. Out on the road across LA and Orange County,
            her family kept seeing the same thing: neighbors without housing whose pets clearly needed
            care no one could afford. And the number behind it was hard to sit with — nearly a million
            dogs and cats are euthanized in the U.S. every year, most of them not because they're
            unwanted, but because the help simply isn't there.
          </p>

          <p className="mb-8 text-gray-700 story-paragraph">
            It started small — food and water in the car, a stop whenever they could. But the need was
            bigger than any one person could carry.
          </p>

          <p className="mb-8 text-gray-700 story-paragraph">
            So they built Pawsitive Future: a straightforward voucher program for spay and neuter
            surgeries — one of the most effective ways to ease shelter overcrowding before it starts.
            With donors, clinics, and local partners, it helps families keep the pets they love and
            breaks the cycle of unwanted litters. It began in Los Angeles, and it's growing from there.
          </p>

          <p className="text-gray-700 story-paragraph">
            Every dog deserves the chance Mischief got.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
